<template>
  <div class="ml-2">
    <v-dialog v-model="dialogCategory" max-width="60%">
      <Category
          :categoryId="categoryId"
          ref="category"
          @close="dialogCategory = false"
          @reload="reloadCategories"
      >
      </Category>
    </v-dialog>

    <v-dialog v-model="deleteDialog" max-width="420px">
      <DeleteModal
          v-if="category && category.id"
          title="Deletar"
          :textMessage="`Você tem certeza que deseja excluir a categoria: ${category.name}?`"
          cancelBtn="Cancelar"
          okbtn="Remover"
          textObservation=""
          icone="mdi-trash-can-outline"
          @close="(deleteDialog = false)"
          @action="deleteCategory"
      />
    </v-dialog>


    <v-data-table
        ref="table"
        :items="combos"
        :loading="loadingCourses"
        :headers="headers"
        hide-default-footer
        loading-text="Buscando..."
        no-data-text="Sem registros"
        class="elevation-0 mytable content-table"
        style="width: 110%"
    >
      <template v-slot:[`item.createdAt`]="{ item }">
        {{ item.createdAt ? formatDate(item.createdAt) : '-' }}
      </template>

      <template v-slot:[`item.actions`]="{ item }">
        <section class=" ">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                  outlined
                  fab
                  tile
                  style="border-radius: 4px"
                  width="35"
                  height="35"
                  small
                  class="ma-1 quinary-button"
                  color="quaternary"
                  @click="showModalEdit(item.id)"
                  v-bind="attrs"
                  v-on="on"
              >
                <v-icon dark>mdi-pencil</v-icon>
              </v-btn>
            </template>
            <span>Editar</span>
          </v-tooltip>

          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                  outlined
                  fab
                  tile
                  style="border-radius: 4px"
                  width="35"
                  height="35"
                  small
                  class="ma-1 remove-button"
                  color="red"
                  @click="showModalDelete(item)"
                  v-bind="attrs"
                  v-on="on"
              >
                <v-icon dark>mdi-trash-can-outline</v-icon>
              </v-btn>
            </template>
            <span>Remover</span>
          </v-tooltip>
        </section>
      </template>

      <template v-slot:footer class="ma-0 pa-0">
        <section class="ma-0 pa-0">
          <Pagination
              v-if="filter.totalItems > filter.pageSize"
              :currentPage="filter.currentPage"
              :totalItems="filter.totalItems"
              :page="filter.page"
              :pageSize="filter.pageSize"
              :totalPages="filter.totalPages"
              @back-page="backPage"
              @next-page="nextPage"
          >
          </Pagination>
        </section>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import ApiService from "../../../../services/ApiService";
import Utils from "../../../../Utils/FormatDate";
import Pagination from "@/views/pages/components/Pagination.vue";
import Category from "@/views/pages/Courses/components/Category.vue";
import DeleteModal from "@/views/pages/components/DeleteModal.vue";
import Vue from "vue";

export default {
  name: "Categories",
  components: {DeleteModal, Category, Pagination},
  computed: {},

  props: {},

  created() {
  },

  async mounted() {
    await this.paginatedList()
  },
  data() {
    return {
      dialogDetailCombo: false,
      loadingCourses: false,
      deleteDialog: false,
      combos: [],
      headers: [
        {
          text: "Nome",
          align: "start",
          value: "name",
          sortable: false,
        },
        {
          text: "Data de cadastro",
          align: "center",
          value: "createdAt",
          sortable: false,
        },
        {
          text: "Ações",
          align: "center",
          value: "actions",
          sortable: false,
        },
      ],
      activeTab: 0,
      apiService: new ApiService(),
      filter: {
        pageSize: 10,
        currentPage: 0,
        page: 1,
        totalPages: 1,
        totalItems: 1,
      },
      dialogCategory: false,
      categoryId: null,
      category: Object,
    };
  },

  methods: {
    formatDate(date) {
      return Utils.moment(date);
    },


    async goToRoute(route) {
      await this.$router.push(route);
    },

    async paginatedList() {
      try {
        const {items, pager} = await this.apiService.post("categoryCourses/paginated", this.filter, false)
        console.log('items')
        console.log(items)
        console.log('items')
        this.combos = items
        this.filter.totalItems = pager.totalItems
        this.filter.currentPage = pager.currentPage
        this.filter.pageSize = pager.pageSize
        this.filter.totalPages = pager.totalPages
      } catch (e) {

      }
    },

    async backPage() {
      this.filter.page -= 1;
      await this.paginatedList();
    },

    async nextPage() {
      this.filter.page += 1;
      await this.paginatedList();
    },

    async showModalEdit(categoryId) {
      this.dialogCategory = true
      this.categoryId = categoryId
      setTimeout(() => {
        this.$refs.category.getCategoryCourses()
      },100)
    },
    async showModalDelete(category) {
      this.deleteDialog = true
      this.category = category
    },
    async deleteCategory() {
      try {
        const response = await this.apiService.delete(`categoryCourses/${this.category.id}`)
        console.log(response)
        Vue.$globalEvent.$emit("onFlashMessage", {
          type: "success",
          title: response.message,
          message: response.message,
          trace: null,
        });
        this.deleteDialog = false
        this.filter.page = 1;
        await this.paginatedList();
      } catch (e) {
        console.log(e)
      }
    },
    async reloadCategories() {
      this.filter.page = 1;
      await this.paginatedList();
    }
  },

  watch: {},
};
</script>

<style lang='scss' scoped>
.mytable .v-table tbody tr {
  border-left: 5px solid red !important;
}

@media (max-width: 1024px) {
  .mytable {
    max-width: 100%;
  }
}
</style>
